module.exports = __webpack_public_path__ + "img/lg_ring_r_o_0_null@2x.1be1e67d.png";